export enum EUserStatus {
    VERIFIED = 'verified',
    NOT_VERIFIED = 'not_verified',
    BLOCKED = 'blocked',
}